import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SortTypeReqModel } from '../model/tb/journal/journal-req.model';

@Injectable({
  providedIn: 'root'
})
export class JournalService {
  private static readonly REMOVE_ADJ_GROUP = environment.apiV1 + '/tb/journal/adj-group';
  private static readonly GET_ADJ_ENTRY_AVAILABLE_DOC = environment.apiV1 + '/tb/journal/available-doc';
  private static readonly GET_ADJUSTMENT_UUIDS = environment.apiV1 + '/tb/journal/adj-uuids';
  private static readonly DELETE_ALL_ADJ_GROUP = environment.apiV1 + '/tb/journal/adj-all-group';
  private static readonly GET_ADJ_ENTRY_DOC_REF = environment.apiV1 + '/tb/journal/adj-entry/document-ref';
  private static readonly GET_PR_ADJ_ENTRY_LEVEL = environment.apiV1 + '/tb/journal/pr-adj-entry-level';
  private static readonly UPDATE_CONVERT_PR_ENTRY_TO_JE = environment.apiV1 + '/tb/journal/convert-pr-entry-to-je';
  private static readonly URI_SAVE_REF = environment.apiV1 + '/tb/journal/ref';
  private static readonly SAVE_TB_ADJ_ENTRY_NEW = environment.apiV1 + '/tb/journal/tb-adj-entry-new';
  private static readonly GET_TRIAL_ADJ_NEXT_GP_NEW = environment.apiV1 + '/tb/journal/trail-adj-next-gp-new';
  private static readonly VIEW_ALL_ADJ_ENTRY_NEW = environment.apiV1 + '/tb/journal/view-all-adj-entry-new';
  private static readonly GET_ADJ_EXPORT_TO_EXCEL = environment.apiV1 + '/tb/journal/export-to-excel';
  private static readonly GET_ADJ_ENTRIES = environment.apiV1 + '/tb/journal/adj-entry';
  private static readonly ADJ_SORT = environment.apiV1 + '/tb/journal/adj-entry/sort';
  private static readonly ADJ_TYPE = environment.apiV1 + '/tb/journal/adj-type';
  private static readonly ALL_ADJ_ENTRY = environment.apiV1 + '/tb/journal/all-trial-adj';
  private static readonly GET_TB_RECORD_ADJ_TYPE_NEW = environment.apiV1 + '/tb/journal/record-adj-type-new';
  private static readonly GET_TB_RECORD_ADJ_TYPE = environment.apiV1 + '/tb/journal/record-adj-type';

  constructor(private http: HttpClient, private toaster: ToastrService) { }

  public removeAdjGroup(engId: number, groupId: number, isDelete: number, adjTypeId: number, trialAdj: string): Observable<GenericResModel<number>> {
    return this.http.delete<GenericResModel<number>>(JournalService.REMOVE_ADJ_GROUP, {
        params:
          {
            engId: engId,
            groupId: groupId,
            isDelete: isDelete,
            adjTypeId: adjTypeId,
            trialAdj: trialAdj
          }
      });
  }

  public getAdjEntryAvailableDoc(engId: number, groupId: number, adjEntryTypeId: number): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_ADJ_ENTRY_AVAILABLE_DOC, {
      params: {
        engId: engId,
        groupId: groupId,
        adjEntryTypeId: adjEntryTypeId
      }
    });
  }

  public getAdjEntryUuids(): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_ADJUSTMENT_UUIDS, {});
  }

  public removeAllAdjGroup(engId: number): Observable<GenericResModel<number>> {
    return this.http.delete<GenericResModel<number>>(JournalService.DELETE_ALL_ADJ_GROUP, {
      params:
        {
          engId: engId
        }
    });
  }

  public getAdjustmentEntryDocRef(engId: number, groupId: number, adjEntryTypeId: number): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_ADJ_ENTRY_DOC_REF, {
      params:
        {
          engId: engId,
          groupId: groupId,
          adjEntryTypeId: adjEntryTypeId
        }
    });
  }

  public getPrAdjEntryLevel(data: string): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_PR_ADJ_ENTRY_LEVEL, {params: {data: data}});
  }

  public updateConvertPrEntryToJe(data: string): Observable<GenericResModel<boolean>> {
    return this.http.put<GenericResModel<boolean>>(JournalService.UPDATE_CONVERT_PR_ENTRY_TO_JE, data);
  }

  public saveAdjEntryRef(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(JournalService.URI_SAVE_REF, data);
  }

  public saveTbAdjEntryNew(data: string): Observable<GenericResModel<string>> {
    return this.http.post<GenericResModel<string>>(JournalService.SAVE_TB_ADJ_ENTRY_NEW, data);
  }

  public getTrailAdjNextGpNew(data: string): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_TRIAL_ADJ_NEXT_GP_NEW, {params: {data: data}});
  }

  public getViewAllAdjEntryNew(data: string): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.VIEW_ALL_ADJ_ENTRY_NEW, {params: {data: data}});
  }

  public getAdjExportToExcel(data: string): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_ADJ_EXPORT_TO_EXCEL, {params: {data: data}});
  }

  public getAdjustmentEntries(engagmentid): Observable<any> {
    return this.http.get<GenericResModel<any>>(JournalService.GET_ADJ_ENTRIES + '/' + engagmentid);
  }

  public saveSortTypeOfAdjEntries(data: SortTypeReqModel): Observable<GenericResModel<SortTypeReqModel>> {
    return this.http.post<GenericResModel<any>>(JournalService.ADJ_SORT, data);
  }

  getAdjustmentType(): Observable<any> {
    return this.http.get(JournalService.ADJ_TYPE);
  }

  public getAllTrialAdjustment(engId: number): Observable<any> {
    return this.http.get(JournalService.ALL_ADJ_ENTRY, {params: {engId: engId}});
  }

  public getTbRecordAdjTypeNew(data: string): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_TB_RECORD_ADJ_TYPE_NEW, {params: {data: data}});
  }

  public getTbRecordAdjType(data: string): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(JournalService.GET_TB_RECORD_ADJ_TYPE, {params: {data: data}});
  }
}
